import { apiRemote } from '../../../../Services/RemoteService';
import * as schedulingApi from '../../SchedulingPage/schedulingApi';
import {
  normalizeProperty,
  transformCreateProperty,
  transformProperty,
} from './utils';

export const createProperty = async (propertyData) => {
  const payload = transformCreateProperty(propertyData);

  const response = await apiRemote.post(`admin/properties`, payload);

  if (!response.ok || response.status !== 200) {
    throw new Error();
  }
};

export const getEmailAvailability = async (emailUserName) => {
  const response = await apiRemote.get(`relay/email/${emailUserName}`);

  if (!response.ok || response.status !== 200) {
    throw new Error();
  }

  const { relay } = await response.json();

  const hasExistingRelayDataForEmailUserName = Boolean(relay);
  const isEmailUserNameAvailable = !hasExistingRelayDataForEmailUserName;

  return isEmailUserNameAvailable;
};

export const getLeasingTeams = async () => {
  const response = await apiRemote.get(`admin/properties/teams`);

  if (!response.ok || response.status !== 200) {
    throw new Error();
  }

  const { leasing_team_users = [] } = await response.json();

  if (leasing_team_users.length) {
    leasing_team_users.sort((a, b) =>
      a.leasing_team_name.localeCompare(b.leasing_team_name, 'en', {
        sensitivity: 'base',
      }),
    );

    leasing_team_users.forEach((team) => {
      team.users.sort((a, b) =>
        a.first_name.localeCompare(b.first_name, 'en', { sensitivity: 'base' }),
      );
    });
  }
  return leasing_team_users;
};

export const getPropertyById = async (propertyId) => {
  const response = await apiRemote.get(
    `admin/properties/property/${propertyId}`,
  );

  if (!response.ok || response.status !== 200) {
    throw new Error();
  }

  const { property = {} } = await response.json();
  const normalizedProperty = normalizeProperty(property);

  return normalizedProperty;
};

export const getPropertyList = async () =>
  await schedulingApi.getPropertyList();

export const updateProperty = async (propertyId, propertyUpdates = {}) => {
  const payload = { property: transformProperty(propertyUpdates) };

  const response = await apiRemote.patch(
    `admin/properties/property/${propertyId}`,
    payload,
  );

  if (!response.ok || response.status !== 204) {
    throw new Error();
  }
};
